import React from 'react';

import { CnuPagination } from './CnuPagination';
import { messageDetailPaginationAtom } from '../../store';

export const MessageDetailPagination = () => {
  return (
    <CnuPagination atom={messageDetailPaginationAtom} hideLabel />
  );
};
